/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import Request from '../../../utils/Request';
import { getDataFromForm } from '../../../utils/misc';
import Manipulator from '../../../utils/dom/manipulator';
import SelectorEngine from '../../../utils/dom/selector-engine';
import Message from '../../../../vendors/FormValidation/plugins/Message';
import Trigger from '../../../../vendors/FormValidation/plugins/Trigger';
import formValidation from '../../../../vendors/FormValidation/core/Core';
import SubmitButton from '../../../../vendors/FormValidation/plugins/SubmitButton';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';

class ClaimLoginDetails {
	constructor() {
		this.form = SelectorEngine.findOne('#claimLoginDetailsForm');
		if (!this.form) return;

		this.init();
	}

	init() {
		this.usernameInput = SelectorEngine.findOne('#username', this.form);
		this.passwordInput = SelectorEngine.findOne('#password', this.form);
		this.emailMarkentingConsentCheckbox = SelectorEngine.findOne('#marketingCheck', this.form);
		this.offerEmailConsentChecbox = SelectorEngine.findOne('#offersCheck', this.form);
		this.globalError = SelectorEngine.findOne('.lta-claim-login-details--fields-error', this.form);

		this.submitUrl = Manipulator.getDataAttribute(this.form, 'submit-url');

		this.usernameRequiredErrorMessage = Manipulator.getDataAttribute(this.form, 'username-required-error');
		this.usernameMinLength = parseInt(Manipulator.getDataAttribute(this.form, 'username-min-length'), 10);
		this.usernameMaxLength = parseInt(Manipulator.getDataAttribute(this.form, 'username-max-length'), 10);
		this.usernameCharacterLengthErrorMessage = Manipulator.getDataAttribute(this.form, 'username-character-lenght-error');
		this.usernameFormatErrorMessage = Manipulator.getDataAttribute(this.form, 'username-format-error');

		this.passwordRequiredErrorMessage = Manipulator.getDataAttribute(this.form, 'password-required-error');
		this.passwordMinLength = parseInt(Manipulator.getDataAttribute(this.form, 'password-min-length'), 10);
		this.passwordMaxLength = parseInt(Manipulator.getDataAttribute(this.form, 'password-max-length'), 10);
		this.passwordCharacterLengthErrorMessage = Manipulator.getDataAttribute(this.form, 'password-character-lenght-error');
		this.passwordFormatErrorMessage = Manipulator.getDataAttribute(this.form, 'password-format-error');

		this.usernameApiUrl = Manipulator.getDataAttribute(this.form, 'username-check-url');
		this.usernameTakenErrorMessage = Manipulator.getDataAttribute(this.form, 'username-taken-error');
		this.usernameCheckApiFailureErrorMessage = Manipulator.getDataAttribute(this.form, 'username-check-api-failure-error');

		this.formSubmitBtn = SelectorEngine.findOne('.js-claim-login-submit', this.form);

		this.usernameAlreadyExists = false;
		this.errorWithUsernameCheck = false;
		this.usernameExistsErrorMessage = '';
		this.isUsernameCheckInProgress = false;

		this.usernameInput.addEventListener('input', () => {
			this.usernameAlreadyExists = false;
			this.errorWithUsernameCheck = false;
			this.isUsernameValid = false;

			const parentWrapper = this.usernameInput.closest('.lta-text-input__wrapper');
			if (parentWrapper) parentWrapper.classList.remove('is-invalid', 'is-focused');

			this.fv.updateFieldStatus('username', 'NotValidated');
			this.fv.disableValidator('username', 'different', false);
			this.fv.disableValidator('username', 'errorCheckingUsername', false);
		});

		if (this.usernameInput) {
			const loader = this.createLoaderForUsernameInput(this.usernameInput);

			this.usernameInput.addEventListener('blur', async (event) => {
				if (event.target.value.trim().length >= 6) {
					await this.checkUsernameAvailability(event, loader);
				}
			});
		}

		this.passwordInput.addEventListener('blur', () => {
			this.fv.revalidateField('password');
		});

		this.errorDismissButton = SelectorEngine.findOne('.js-dismiss-error', this.globalError);

		if (this.errorDismissButton) {
			this.errorDismissButton.addEventListener('click', () => {
				this.globalError.classList.add('u-hidden');
			});
		}
		this.setupValidation();
	}

	createLoaderForUsernameInput() {
		const wrapper = document.createElement('div');
		wrapper.classList.add('input-with-loader');
		this.usernameInput.parentNode.insertBefore(wrapper, this.usernameInput);
		wrapper.appendChild(this.usernameInput);

		// Creating loader inside wrapper
		const loader = document.createElement('span');
		loader.className = 'lta-field-loader';
		wrapper.appendChild(loader);
		return loader;
	}

	async checkUsernameAvailability(event, loader) {
		const username = event.target.value.trim();
		if (!username) return;

		if (username.length < 6 || username.length > 18) {
			this.fv.updateFieldStatus('username', 'Invalid', 'stringLength');
			return;
		}

		if (!/^[\w\d_.-]+$/.test(username)) {
			this.fv.updateFieldStatus('username', 'Invalid', 'regexp');
			return;
		}

		await this.fv.updateFieldStatus('username', 'Valid');

		this.isUsernameCheckInProgress = true;
		this.isUsernameValid = false;
		this.usernameAlreadyExists = false;
		this.usernameExistsErrorMessage = '';
		loader.style.display = 'inline-block';
		this.usernameInput.style.pointerEvents = 'none';
		this.fv.updateFieldStatus('username', 'Valid');

		if (this.pendingSubmit && this.isUsernameValid) {
			this.pendingSubmit = false;
			this.formSubmitBtn.click();
			return;
		}
		try {
			const response = await Request.post(this.usernameApiUrl, { username });
			loader.style.display = 'none';
			this.usernameInput.style.pointerEvents = '';
			this.isUsernameCheckInProgress = false;

			const { accountExists, statusCode } = response;

			if (accountExists) {
				this.usernameAlreadyExists = true;
				this.isUsernameValid = false;
				this.fv
					.updateValidatorOption('username', 'different', 'compare', () => this.usernameInput.value)
					.updateFieldStatus('username', 'Invalid', 'different');
				const parentWrapper = this.usernameInput.closest('.lta-text-input__wrapper');
				if (parentWrapper) parentWrapper.classList.add('is-invalid', 'is-focused');
				return;
			}

			if (!accountExists && statusCode == '99') {
				this.errorWithUsernameCheck = true;
				this.usernameExistsErrorMessage = this.usernameCheckApiFailureErrorMessage;
				this.isUsernameValid = false;
				this.fv.updateFieldStatus('username', 'Invalid', 'errorCheckingUsername');
				const parentWrapper = this.usernameInput.closest('.lta-text-input__wrapper');
				if (parentWrapper) parentWrapper.classList.add('is-invalid', 'is-focused');
				return;
			}

			this.isUsernameValid = true;
			this.usernameAlreadyExists = false;
			this.errorWithUsernameCheck = false;
			this.usernameExistsErrorMessage = '';
			this.fv.updateFieldStatus('username', 'Valid');
			const parentWrapper = this.usernameInput.closest('.lta-text-input__wrapper');
			if (parentWrapper) parentWrapper.classList.remove('is-invalid', 'is-focused');
		} catch (err) {
			console.error('Username check API error:', err);
			loader.style.display = 'none';
			this.usernameInput.style.pointerEvents = '';
			this.isUsernameValid = false;
			this.isUsernameCheckInProgress = false;
		}
	}

	setupValidation() {
		const that = this;

		this.fv = formValidation(this.form, {
			fields: {
				username: {
					validators: {
						notEmpty: {
							message: this.usernameRequiredErrorMessage
						},
						stringLength: {
							min: this.usernameMinLength,
							max: this.usernameMaxLength,
							message: this.usernameCharacterLengthErrorMessage
						},
						regexp: {
							regexp: /^[\w\d_.-]+$/,
							message: this.usernameFormatErrorMessage
						},
						errorCheckingUsername: {
							message: this.usernameCheckApiFailureErrorMessage
						},
						different: {
							compare: () => '',
							message: this.usernameTakenErrorMessage
						}
					}
				},
				password: {
					validators: {
						notEmpty: {
							message: this.passwordRequiredErrorMessage
						},
						stringLength: {
							min: this.passwordMinLength,
							max: this.passwordMaxLength,
							message: this.passwordCharacterLengthErrorMessage
						},
						regexp: {
							regexp: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,\-.\\\/:;<=>?@[\]^_`{|}~])/g,
							message: this.passwordFormatErrorMessage
						},
						different: {
							compare: () => SelectorEngine.findOne('[name="username"]', this.form).value,
							message: 'Please create a password that is different to your username'
						}
					}
				}
			},
			plugins: {
				trigger: new Trigger(),
				submitButton: new SubmitButton(),
				message: new Message({
					clazz: 'lta-text-input__label-instruction',
					container(_, element) {
						const wrapper = element.closest('.lta-text-input__wrapper');
						return wrapper.querySelector('.lta-text-input--error');
					}
				})
			}
		})
			.on('core.field.invalid', (name) => {
				const field = SelectorEngine.findOne(`[name="${name}"]`, this.form);
				const wrapper = field.closest('.lta-text-input__wrapper');
				wrapper.classList.add('is-invalid', 'is-focused');
			})
			.on('core.field.valid', (name) => {
				const field = SelectorEngine.findOne(`[name="${name}"]`, this.form);
				const wrapper = field.closest('.lta-text-input__wrapper');
				wrapper.classList.remove('is-invalid', 'is-focused');
			})
			.on('core.form.invalid', () => {
				const firstInvalid = SelectorEngine.findOne('.is-invalid', this.form);
				if (firstInvalid) firstInvalid.parentNode.scrollIntoView({ behavior: 'smooth' });
			})
			.on('core.form.valid', () => {
				const scrollToFieldError = (wrapper) => {
					if (!wrapper) return;
					wrapper.classList.add('is-invalid', 'is-focused');
					setTimeout(() => {
						wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}, 100);
				};

				if (this.isUsernameCheckInProgress) {
					this.pendingSubmit = true;

					const wrapper = this.usernameInput.closest('.lta-text-input__wrapper');
					if (wrapper) {
						wrapper.classList.add('is-focused');
						wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
					this.usernameInput.blur();
					return;
				}

				if (!this.isUsernameValid) {
					scrollToFieldError(this.usernameInput.closest('.lta-text-input__wrapper'));
					this.formSubmitBtn.disabled = false;
					return;
				}

				if (this.usernameAlreadyExists) {
					this.fv.updateFieldStatus('username', 'Invalid', 'different');
					scrollToFieldError(this.usernameInput.closest('.lta-text-input__wrapper'));
					this.formSubmitBtn.disabled = false;
					return;
				}

				if (this.errorWithUsernameCheck) {
					this.fv.updateFieldStatus('username', 'Invalid', 'errorCheckingUsername');
					scrollToFieldError(this.usernameInput.closest('.lta-text-input__wrapper'));
					this.formSubmitBtn.disabled = false;
					return;
				} else {
					const payload = this.preparePayload();
					this.submit(payload);
				}
			});
	}

	preparePayload() {
		const dataObject = getDataFromForm(this.form);
		const newDataObject = {
			...dataObject,
			username: this.usernameInput.value.trim(),
			password: this.passwordInput.value,
		};
		return newDataObject;
	}

	async submit(data) {
		if (SelectorEngine.findOne('.is-invalid', this.form)) {
			const firstInvalid = SelectorEngine.findOne('.is-invalid', this.form);
			firstInvalid.scrollIntoView({ behavior: 'smooth' });
			return;
		}

		startLoadingAnimation(true);
		try {
			const response = await Request.post(this.submitUrl, data);

			const { success, errorMessage, redirectUrl } = response;

			if (!success && errorMessage !== '') {
				stopLoadingAnimation();
				this.showErrorContainer(errorMessage || 'Unable to create account');
				return;
			} else {
				window.location.href = redirectUrl;
			}
		} catch {
			stopLoadingAnimation();
			this.showErrorContainer('Something went wrong, Unable to create account. Please try again.');
		}
	}

	showErrorContainer(message) {
		if (!this.globalError) return;

		const errorTextElement = this.globalError.querySelector('.error-text');
		if (errorTextElement) {
			errorTextElement.innerHTML = message;
		}

		this.globalError.classList.remove('u-hidden');

		this.globalError.scrollIntoView({
			behavior: 'smooth',
			block: 'center'
		});
	}
}

const globalClaimLoginDetails = new ClaimLoginDetails();
export default globalClaimLoginDetails;

/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
